"use client"

import * as React from "react"
import * as TabsPrimitive from "@radix-ui/react-tabs"

import { cn } from "@workspace/ui/lib/utils"

function Tabs({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Root>) {
  return (
    <TabsPrimitive.Root
      data-slot="tabs"
      className={cn("flex flex-col gap-2", className)}
      {...props}
    />
  )
}

function TabsList({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.List>) {
  return (
    <TabsPrimitive.List
      data-slot="tabs-list"
      className={cn(
        "bg-secondary/50 dark:bg-secondary/30 text-secondary-foreground",
        "border border-border ring-1 ring-white/10 dark:ring-white/5 shadow-xs",
        "inline-flex h-10 w-fit items-center justify-center rounded-lg p-1.5 gap-2",
        className
      )}
      {...props}
    />
  )
}

function TabsTrigger({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Trigger>) {
  return (
    <TabsPrimitive.Trigger
      data-slot="tabs-trigger"
      className={cn(
        "hover:bg-background/70 dark:hover:bg-background/40",
        "hover:border hover:border-border",
        "hover:ring-1 hover:ring-white/10 dark:hover:ring-white/5 hover:shadow-xs",
        "data-[state=active]:bg-background/90 data-[state=active]:text-foreground",
        "data-[state=active]:border-border",
        "data-[state=active]:ring-1 data-[state=active]:ring-white/10 dark:data-[state=active]:ring-white/5",
        "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:outline-ring",
        "text-secondary-foreground/70 hover:text-secondary-foreground dark:text-muted-foreground/70 dark:hover:text-muted-foreground inline-flex h-8 flex-1 items-center justify-center gap-1.5 rounded-md border border-transparent px-3 py-1.5 text-sm font-medium whitespace-nowrap transition-[background-color,color,border-color,box-shadow,transform] focus-visible:ring-[3px] focus-visible:outline-1 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:shadow-sm [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        className
      )}
      {...props}
    />
  )
}

function TabsContent({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Content>) {
  return (
    <TabsPrimitive.Content
      data-slot="tabs-content"
      className={cn("flex-1 outline-none", className)}
      {...props}
    />
  )
}

export { Tabs, TabsList, TabsTrigger, TabsContent }
